import * as actionTypes from './actionTypes';
import { getFormValues } from 'redux-form';
import { formatDate } from '@app/src/utils/helpers';

const setStartDateErrorMessage = (errorMessage: string) => ({
  type: actionTypes.SET_START_DATE_ERROR_MESSAGE,
  errorMessage
});

const setEndDateErrorMessage = (errorMessage: string) => ({
  type: actionTypes.SET_END_DATE_ERROR_MESSAGE,
  errorMessage
});

interface DateType {
  selected: string;
  position: string;
}

export const validateSelectedDateRange = (date: DateType) => {
  return (dispatch, getState) => {
    const state = getState();
    const { selected, position } = date;
    const { dateStart, dateEnd } = getFormValues('filter')(state);
    const selectedDate: Date = formatDate(selected);
    const startDate: Date = formatDate(dateStart);
    const endDate: Date = formatDate(dateEnd);
    const isSelectedStartDatePosition: boolean = position === 'start';
    const isSelectedEndDatePosition: boolean = position === 'end';
    const isSelectedDateGreaterThanEndDate: boolean = selectedDate > endDate;
    const isSelectedDateLessThanStartDate: boolean = startDate > selectedDate;

    if(isSelectedStartDatePosition) {
      isSelectedDateGreaterThanEndDate
        ? dispatch(setStartDateErrorMessage('Fecha Inicio inválida'))
        : dispatch(setStartDateErrorMessage(''));
    }
    if(isSelectedEndDatePosition) {
      isSelectedDateLessThanStartDate
        ? dispatch(setEndDateErrorMessage('Fecha Fin inválida'))
        : dispatch(setEndDateErrorMessage(''));
    }
  };
};


